export default class Permissions {
  public RemoteConnection? = false;
  public Administrator? = false;
  public AccessToAllCompanies? = true;
  public ManageCompanies? = false;
  public McpFullAccess? = false;
  public McpReadAccess? = false;
}
